import React from 'react';
import {AppBar, IconButton, styled, Toolbar} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import {useNavigate} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import Button from "@mui/material/Button";
import {sidebarActiveState} from "../states/common/layoutAtom";
import {useNavbar} from "../states/common/client";

const NavigationBar: React.FC = () => {
    const { navbar } = useNavbar()
    const navigate = useNavigate();
    const setSidebarActive = useSetRecoilState(sidebarActiveState);

    function handleBackButton() {
        if (!navbar.hasBackButton) {
            return; // 백버튼이 표시되지 않는 상태. 아무 일도 일어나지 않는다.
        }
        navigate(-1);
    }

    function handleMenuButton() {
        setSidebarActive(true)
    }

    const renderRightButton = () => {
        if (navbar.hasSettingsButton) {
            return <Button onClick={() => { navigate('/settings') }} sx={{color: '#555'}}>설정</Button>;
        }

        return <IconButton onClick={handleMenuButton}><MenuIcon/></IconButton>;
    }

    const StyledToolbar = styled(Toolbar)({
        minHeight: '56px',
        backgroundColor: navbar.backgroundColor,
        '@media (min-width: 430px)': {
            minHeight: '56px',
        }
    });

    return (
        <AppBar position="fixed" style={{boxShadow: "none"}}>
            <StyledToolbar>
                <IconButton onClick={handleBackButton}
                            style={{visibility: navbar.hasBackButton ? 'visible' : 'hidden'}}><ArrowBackIcon/></IconButton>
                <h2 className="navbar-title" style={{color: '#555'}}>{navbar.pageTitle}</h2>
                {renderRightButton()}
            </StyledToolbar>
        </AppBar>
    );
}

export default NavigationBar;